<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleStatusDetailSection from './PostSaleStatusDetailSection.vue';
import {
  first,
  listOf,
  payloadOf,
  textOf,
} from './postSaleStatusDetailPresenter';

const props = defineProps({ event: { type: Object, required: true } });
const { t } = useI18n();
const sections = computed(() => {
  const payload = payloadOf(props.event);
  const responsible = first(payload.responsaveis_venda);
  const empty = t('POST_SALE.COMMON.EMPTY_VALUE');

  return [
    {
      title: t('POST_SALE.STATUS_DETAILS.PEOPLE'),
      items: [
        {
          label: t('POST_SALE.STATUS_DETAILS.SELLER_RESPONSIBLE'),
          value: textOf(
            responsible.nome_vendedor || payload.responsavel_vendedor,
            empty,
            t
          ),
        },
        {
          label: t('POST_SALE.STATUS_DETAILS.BUYER_RESPONSIBLE'),
          value: textOf(
            responsible.nome_comprador || payload.responsavel_comprador,
            empty,
            t
          ),
        },
      ],
    },
    {
      title: t('POST_SALE.STATUS_DETAILS.TAXES'),
      items: [
        {
          label: t('POST_SALE.STATUS_DETAILS.MUNICIPAL_REGISTRATION'),
          value: textOf(payload.inscricao_municipal, empty, t),
        },
        {
          label: t('POST_SALE.STATUS_DETAILS.PENDING_ITEMS'),
          value: listOf(payload.pendencias || payload.pendencia_taxa, empty, t),
        },
      ],
    },
  ];
});
</script>

<template>
  <div class="grid gap-4">
    <PostSaleStatusDetailSection
      v-for="section in sections"
      :key="section.title"
      v-bind="section"
    />
  </div>
</template>
